import {
    FILE_ICON_PDF,
    FILE_ICON_DOC,
    FILE_ICON_XLS,
    FILE_ICON_CSV,
    FILE_ICON_PPT,
    FILE_ICON_TEXT,
    FILE_ICON_MD,
    FILE_ICON_HTML,
} from '../../../../../../../../assets/hostedassets';

/** Maps a file extension (lower-cased) to its display icon. */
export const FILE_TYPE_ICONS: Record<string, string> = {
    pdf: FILE_ICON_PDF,
    doc: FILE_ICON_DOC,
    docx: FILE_ICON_DOC,
    xls: FILE_ICON_XLS,
    xlsx: FILE_ICON_XLS,
    csv: FILE_ICON_CSV,
    ppt: FILE_ICON_PPT,
    pptx: FILE_ICON_PPT,
    txt: FILE_ICON_TEXT,
    text: FILE_ICON_TEXT,
    md: FILE_ICON_MD,
    html: FILE_ICON_HTML,
};

/** Fallback icon when the extension has no specific mapping. */
export const DEFAULT_FILE_ICON = FILE_ICON_DOC;

/** The lower-cased extension an icon is chosen by: an explicit file type wins over the name's suffix. */
export const getFileExtension = (fileName: string, fileType?: string): string => {
    if (fileType) return fileType.toLowerCase();
    const dotIndex = fileName.lastIndexOf('.');
    return dotIndex === -1 ? '' : fileName.slice(dotIndex + 1).toLowerCase();
};

/** The display icon for a file, by explicit type when given, else by the name's extension. */
export const getFileIcon = (fileName: string, fileType?: string): string =>
    FILE_TYPE_ICONS[getFileExtension(fileName, fileType)] ?? DEFAULT_FILE_ICON;
